import React from 'react'

export default function AED({value=0,size=10}) {
  return (
    <span>{value.toFixed(2)} <i style={{fontSize:`${size}px`}}>AED</i></span>
  )
}
